import { useEffect, useState } from 'react'

/** `Date.now()`, refreshed immediately and then every second while `active`. */
export function useNowTick(active: boolean): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!active) return
    const first = setTimeout(() => setNow(Date.now()), 0)
    const handle = setInterval(() => setNow(Date.now()), 1000)
    return () => {
      clearTimeout(first)
      clearInterval(handle)
    }
  }, [active])
  return now
}
